import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { openTrackedOutboundUrl } from "../../utils/trackOutboundClick";
import { readHomeChatMatchSessionId } from "../../utils/homeChatMatchPersistence";
import styles from "../../styles/pages/product/ProductDetailsPage.module.css";

function formatCheckedAgo(iso) {
  if (!iso) return "not checked yet";
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return "not checked yet";
  const hours = Math.max(0, Math.round((Date.now() - then) / 3600000));
  if (hours < 1) return "checked just now";
  if (hours === 1) return "checked 1h ago";
  if (hours < 48) return `checked ${hours}h ago`;
  return "checked over 48h ago";
}

function formatOfferAmount(amount, currency) {
  const formatted = Number(amount).toLocaleString("en-US");
  return currency === "USD" ? `$${formatted}` : `CA$${formatted}`;
}

export function visibleRetailerOffers(product) {
  const offers = Array.isArray(product?.liveOffers) ? product.liveOffers : [];
  return offers.filter((offer) => {
    const price = Number(offer?.price ?? offer?.amount);
    return (
      Number.isFinite(price) &&
      offer?.url &&
      offer?.retailerName &&
      offer?.status !== "blocked" &&
      offer?.status !== "wrong_product" &&
      offer?.status !== "page_gone" &&
      offer?.status !== "needs_review" &&
      offer?.status !== "stale"
    );
  });
}

const ProductRetailerOffers = ({ product }) => {
  const offers = visibleRetailerOffers(product);
  if (!offers.length) return null;

  const handleClick = async (offer) => {
    if (!offer?.url) return;
    await openTrackedOutboundUrl({
      url: offer.url,
      productId: product?._id,
      source: "product_details",
      linkType: "retailer",
      sessionId: readHomeChatMatchSessionId() || undefined,
      metadata: { retailer: offer.retailerName },
    });
  };

  return (
    <div className={styles.retailerOfferList}>
      {offers.map((offer) => {
        const price = Number(offer.price ?? offer.amount);
        return (
          <div key={`${offer.retailerName}-${offer.url}`} className={styles.retailerOfferRow}>
            <div className={styles.retailerOfferMeta}>
              <span className={styles.retailerOfferName}>{offer.retailerName}</span>
              <span className={styles.retailerOfferPrice}>
                {formatOfferAmount(price, offer.currency)}
              </span>
              <span className={styles.retailerOfferChecked}>
                {formatCheckedAgo(offer.checkedAt || offer.lastSuccessAt)}
              </span>
            </div>
            <button
              type="button"
              className={styles.productBuyBtn}
              onClick={() => handleClick(offer)}
            >
              See at {offer.retailerName}
              <FaExternalLinkAlt className={styles.productBuyBtnIcon} aria-hidden />
            </button>
          </div>
        );
      })}
      <p className={styles.retailerOfferDisclaimer}>
        Prices observed on retailer pages. Confirm on the retailer site.
      </p>
    </div>
  );
};

export { formatCheckedAgo };
export default ProductRetailerOffers;
